// extracted by mini-css-extract-plugin
export default {"eventList":"ListEventCardGroup-module__eventList___24nhv"};